import APIService from '../api';

export default class ChangeUserType extends APIService {
  changeToken() {
    return this.get('/auth/switch-token/customer');
  }
}
